import React, { useState, useEffect } from 'react';

const partners = [
  { name: 'Tata AIG', logo: '/assets/partners/tata-aig.png' },
  { name: 'Go Digit', logo: '/assets/partners/go-digit.png' },
  { name: 'Bajaj Allianz', logo: '/assets/partners/bajaj-allianz.png' },
  { name: 'ICICI Lombard', logo: '/assets/partners/icici-lombard.png' },
  { name: 'HDFC ERGO', logo: '/assets/partners/hdfc-ergo.png' },
  { name: 'The New Assurance', logo: '/assets/partners/the-new-assurance.png' }
];

const InsurancePartners = ({ variant = 'slider' }) => {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    if (variant !== 'slider') return;

    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % partners.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [variant]);

  return (
    <section className="partners-section">
      <div className="container">
        <h2 className="section-title">Our Insurance Partners</h2>

        {variant === 'slider' ? (
          <>
            <div className="partners-slider">
              {partners.map((partner, index) => (
                <div
                  key={index}
                  className={`partner-card ${index === currentSlide ? 'active' : ''}`}
                >
                  <div className="partner-logo">
                    <img src={partner.logo} alt={`${partner.name} logo`} />
                  </div>
                </div>
              ))}
            </div>
            <div className="slider-dots">
              {partners.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                ></span>
              ))}
            </div>
          </>
        ) : (
          <div className="partners-grid">
            {partners.map((partner) => (
              <div key={partner.name} className="partner-card partner-card-grid">
                <div className="partner-logo">
                  <img src={partner.logo} alt={`${partner.name} logo`} />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default InsurancePartners;


